import Vue from 'vue';
import vueOptsHeatmapHeaderSelector from './HeatmapHeaderSelector.vue';

export default class HeatmapHeaderSelector {
  constructor(settings, options) {
    const Ctor = Vue.extend(vueOptsHeatmapHeaderSelector);
    this.vm = new Ctor({
      propsData: {
        data: options.data,
        dtSettings: settings,
      },
    }).$mount();
  }

  node() {
    return this.vm.$el;
  }
}
